export enum WorkerMotivationEnum {
  FIND_JOB = 'FIND_JOB',
  EMPLOYER = 'EMPLOYER',
  RIGHTS = 'RIGHTS',
  OTHER = 'OTHER',
}
